const RECENT_SEARCHES_KEY = 'global_recent_searches'
const MAX_RECENT = 8

export function getRecentSearches(): string[] {
  try {
    const parsed = JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY) ?? '[]')
    return Array.isArray(parsed)
      ? parsed.filter((item): item is string => typeof item === 'string')
      : []
  } catch {
    return []
  }
}

export function addRecentSearch(query: string) {
  const trimmed = query.trim()
  if (!trimmed) return

  try {
    const next = [trimmed, ...getRecentSearches().filter((item) => item !== trimmed)].slice(0, MAX_RECENT)
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(next))
  } catch {
    // Storage can be unavailable in private browsing; search should still work.
  }
}

export function clearRecentSearches() {
  try {
    localStorage.removeItem(RECENT_SEARCHES_KEY)
  } catch {
    // Ignore storage failures.
  }
}
